import React from 'react';
import LinearProgress from '@mui/material/LinearProgress'

// ==============================|| LOADER ||============================== //
const Loader = () => (
    <div className='loader'>
        <LinearProgress color='primary' />
    </div>
)

export default Loader
